import React from 'react';
import 'moment/locale/pt-br';
import { Form, DatePicker } from 'antd';

const FilterRangePicker = ({
  name,
  initialValue,
  ranges = [],
  noStyle = true,
  label,
  width,
  allowClear,
  className
}) => {
  return (
    <Form.Item
      className={className}
      name={name}
      noStyle={noStyle}
      initialValue={initialValue}
      label={label}
    >
      <DatePicker.RangePicker
        className="gx-mr-1"
        format="DD/MM/YYYY"
        style={{ width: width ?? '100%' }}
        ranges={ranges}
        allowClear={allowClear}
      />
    </Form.Item>
  );
};

export default FilterRangePicker;
